import {
  AbsoluteCenter,
  Box,
  Center,
  Flex,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// import SplashPng from "../assets/splash.png"; // relative path to image
import imageGraphicMeetDark from "../assets/graphic-meet-dark.svg"; // relative path to image
import imageGraphicMeetLight from "../assets/graphic-meet-light.svg"; // relative path to image
import { Logo } from "../components/shared/Logo";

// Auth Layout
// Handles the top level view of the auth routes

const AuthLayout = ({ children }) => {
  const imageGraphicMeetSrc = useColorModeValue(
    imageGraphicMeetLight,
    imageGraphicMeetDark
  );

  return (
    <Flex
      h="100vh"
      bg={"bg.main"}
      color={"text.main"}
      overflowY={{ base: "scroll", lg: "inherit" }}
      direction={{ base: "column", lg: "row-reverse" }}
    >
      <Box
        flex={2}
        maxH={{ base: "24", md: "48", lg: "inherit" }}
        position="relative"
        overflow={"hidden"}
        bg={"primary.700"}
      >
        <Box p={8}>
          <Center>
            <Logo.White w={{ base: 32, md: 48, "2xl": 56 }} />
          </Center>
        </Box>
        <AbsoluteCenter display={{ base: "none", lg: "block" }} w="full">
          <Stack spacing={6}>
            <Center>
              <Image maxW="xl" src={imageGraphicMeetSrc} alt="" />
            </Center>
            <Stack>
              <Text
                textAlign={"center"}
                fontSize="3xl"
                fontWeight={"semibold"}
                color="gray.100"
              >
                The Bridge To Your Community
              </Text>
              <Center>
                <Text
                  textAlign={"center"}
                  fontSize="lg"
                  color="gray.200"
                  maxW="sm"
                >
                  Securely rent your data for decentralized analysis on a
                  transactional basis without sacrificing privacy, ownership, or
                  control.
                </Text>
              </Center>
            </Stack>
          </Stack>
        </AbsoluteCenter>
      </Box>
      <Box flex={{ base: 2, lg: 1 }} overflowY={"scroll"} position="relative">
        <Box
          position={"relative"}
          px={{ base: "16", lg: "10", xl: "28" }}
          py={{ base: "8", lg: "8" }}
        >
          <Box
            maxW={{ lg: "420px" }}
            pt={{ base: "8", lg: "16" }}
            pb={{ base: "8", lg: "16" }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default AuthLayout;
